import { API, authClient } from '..'

export const getOfferImports = (accessToken) =>
	authClient(accessToken).get(`${API}/offer-imports`)

export const getOfferImport = (id, accessToken) =>
	authClient(accessToken).get(`${API}/offer-imports/${id}`)

export const deleteOfferImport = (id, accessToken) => authClient(accessToken).delete(`${API}/offer-imports/${id}`)
export const acceptPendingOfferImport = (id, accessToken) => authClient(accessToken).post(`${API}/offer-imports/${id}/accept-pending`)

export const analyzeOfferImport = (id, accessToken) => authClient(accessToken).post(`${API}/offer-imports/${id}/analyze`)
export const getImportCategories = (accessToken) => authClient(accessToken).get(`${API}/offer-imports/categories`)
export const reviewImportChapter = (id, chapter, data, accessToken) => authClient(accessToken).put(`${API}/offer-imports/${id}/chapters/${chapter}`, data)
export const reviewImportLine = (id, line, data, accessToken) => authClient(accessToken).put(`${API}/offer-imports/${id}/lines/${line}`, data)
export const searchImportTemplates = (id, query, offset, accessToken) => authClient(accessToken).get(`${API}/offer-imports/${id}/catalog`, { params: { query, offset } })
export const getImportTemplate = (id, template, accessToken) => authClient(accessToken).get(`${API}/offer-imports/${id}/catalog/${template}`)
export const convertOfferImport = (id, data, accessToken) => authClient(accessToken).post(`${API}/offer-imports/${id}/convert`, data)

export const updateOfferImportLineOwnership = (id, line, specificToCustomer, accessToken) =>
	authClient(accessToken).put(`${API}/offer-imports/${id}/lines/${line}/ownership`, { crear_plantilla_especifica_cliente: specificToCustomer })

export const postOfferImport = (clienteId, file, specificToCustomer, accessToken) => {
	const form = new FormData()
	form.append('cliente_id', clienteId)
	form.append('archivo', file)
	form.append('crear_partidas_especificas_cliente', specificToCustomer ? 'true' : 'false')
	return authClient(accessToken).post(`${API}/offer-imports`, form, {
		headers: { 'Content-Type': 'multipart/form-data' },
	})
}
